const passportDocumentType = {
  value: "PASSPORT",
  displayName: "Pasaporte"
};
const documentTypesByCountry = {
  AR: [passportDocumentType],
  BO: [passportDocumentType],
  BR: [passportDocumentType],
  CL: [passportDocumentType],
  CO: [
    { value: "RUT", displayName: "RUT" },
    { value: "NIT", displayName: "NIT" },
    passportDocumentType,
    { value: "CE", displayName: "C\xE9dula de extranjer\xEDa" },
    { value: "CC", displayName: "C\xE9dula de ciudadan\xEDa" }
  ],
  EC: [
    passportDocumentType,
    { value: "CI", displayName: "C\xE9dula de identidad" },
    { value: "RUC", displayName: "RUC" }
  ],
  PY: [passportDocumentType],
  PE: [passportDocumentType],
  UY: [passportDocumentType],
  VE: [passportDocumentType],
  US: [passportDocumentType]
};

export { documentTypesByCountry };
//# sourceMappingURL=bundle.esm3.js.map
